export const emojis = [
  {emoji: '💯', name: 'hundred'},
  {emoji: '😂', name: 'laughing'},
  {emoji: '❤️', name: 'heart'},
  {emoji: '🔥', name: 'fire'},
];
